export const verticalStepperStyle = {
	wrapper: {
		maxWidth: '394px',
		// marginBottom: 'auto',
		marginBottom: '288px',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'start',
		textAlign: 'start',
		zIndex: 2,
	},

	stepper: {
		height: '400px',

		'& .MuiStep-root': {
			'&:nth-of-type(3n) .MuiStepLabel-labelContainer': {
				marginTop: '38px',
			},

			'&:nth-of-type(5n) .MuiStepLabel-iconContainer': {
				marginTop: '-60px',
			},
		},

		'& .MuiStepConnector-root': {
			marginLeft: '16px',

			'& .MuiStepConnector-line': {
				borderRadius: 'unset',
				borderColor: 'var(--default-white) !important',
				borderWidth: '1px',
				height: '100%',
				minHeight: '102px',
				marginTop: '-12px',
			},

			'&:nth-of-type(2n) .MuiStepConnector-line': {
				position: 'relative',
				top: '20px',
			},

			'&:nth-of-type(4n) .MuiStepConnector-line': {
				position: 'relative',
				top: '-14px',
			},
		},
	},

	label: {
		padding: '0px',

		'& .MuiStepLabel-labelContainer': {
			'& .MuiStepLabel-label': {
				fontSize: '16px',
				fontWeight: 700,
				color: 'var(--default-white)',
			},

			'& .MuiTypography-root': {
				fontSize: '14px',
				fontWeight: 400,
				color: 'var(--primary-200)',
			},
		},
	},
};
